import $ from "jquery/dist/jquery";

$(() => {
  $(document).on("click", ".shop-this, .shop-this-fast", function (e) {
    e.preventDefault();
    let btn = $(this);

    let quantity = 1;
    let qt = btn.attr("data-quantity");
    if (qt) {
      quantity = parseInt(qt) || 1;
    } else {
      qt = btn.attr("data-quantity-target");
      if (qt) {
        quantity = parseInt($(qt).val()) || 1;
      }
    }

    $.ajax({
      url: window.NXURLS.URL_ESHOP_ADD_TO_CART,
      method: "POST",
      data: {
        itemId: parseInt(btn.attr("data-item")),
        quantity: quantity,
        addonIds: Array.from($('input[name="addonId"]')).map((x) => $(x).val()),
      },
    })
      .done((data) => {
        $(document).trigger("eshop:item-add", [data.gtmJSONs]);

        if (btn.hasClass("shop-this-fast")) {
          $(document).trigger("eshop:add-fast", data);
        } else {
          if (btn.hasClass("no-eshop-modal")) {
            $(document).trigger("eshop:add", [data, false, btn.hasClass("eshop-refresh-page")]);
          } else {
            $(document).trigger("eshop:add", data);
          }
        }
      })
      .fail(() => {
        window.NXCMS.toast("Nepovedlo se přidat!", 4000);
      });
  });

  $(".remove-item").click((e) => {
    e.preventDefault();
    $(this).parents("tr").fadeOut();
  });

  $(document).on("click", ".btn-addon-add", function (e) {
    e.preventDefault();
    let btn = $(this);

    let detail = $(".addon-detail-data");
    detail.find(".name").html(btn.attr("data-addon-name"));
    if (btn.attr("data-addon-image")) {
      detail.find(".color").css({ "background-image": `${btn.attr("data-addon-image")}` });
      detail.find(".color").css({ "background-size": "cover" });
    }
    if (btn.attr("data-addon-color")) {
      detail.find(".color").css({ "background-color": `#${btn.attr("data-addon-color")}` });
      detail.find(".color").css({ "background-image": "none" });
    }

    detail.find(".price").html(btn.attr("data-addon-price"));

    detail.find('input[name="addonId"]').val(btn.attr("data-addon-id"));
    detail.show();

    $(document).trigger("eshop:addon-selected");

    return false;
  });

  $(document).on("click", ".btn-addon-remove", function (e) {
    e.preventDefault();
    let detail = $(".addon-detail-data");
    detail.find(".name").html("");
    detail.find(".color").css("background-color", "transparent");
    detail.find(".price").html("");
    detail.find('input[name="addonId"]').val("");
    detail.hide();

    return false;
  });

  let detail = $(".addon-detail-data");
  if (!detail.find(".price").html()) {
    detail.find('input[name="addonId"]').val("");
  }
});
